import { useEffect, useState } from "react";
import { useUserStore } from "../store/userStore";

export const useShowExploreStudio = () => {
  const [showStudioPopup, setShowStudioPopup] = useState<boolean>(false);
  const verifiedUser = useUserStore((state) => state.currentUser?.verified);

  const onCloseStudioPopup = () => {
    setShowStudioPopup((prev) => !prev);
  };

  useEffect(() => {
    if (verifiedUser) {
      setShowStudioPopup(true);
    }
  }, [verifiedUser]);

  return { showStudioPopup, onCloseStudioPopup };
};
